import React from "react";
import { Box, Button, Card, Table, TableBody, TableCell, TableHeader, TableRow, Text } from "grommet";
import { getMisEnRelationApporteurs, getSorted } from "../service";
import Refresh from "../../elements/refresh";
import SearchComponent from "../../elements/search";
import DateSort from "../../elements/date_sort";
import { getSimpleDateFR } from "../../../services/utils";
import CustomSelect from "../../elements/select_fill";
import { Add } from "grommet-icons";
import { getUser } from "../../../services/storage_service";
class RelationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leads: [],
      popupOpen: false,
      selectedUser: {},
      statut: null,
      filter: {
        _query: undefined,
        status: undefined,
        sort: undefined
      }
    };
  }
  componentDidMount = () => {
    this.loadRelations();
  };

  loadRelations = () => {
    this.setState({ leads: [] }, () => {
      var params = {};
      if (this.state.statut) {
        params["status"] = this.state.statut;
      }
      if (this.state.query) {
        params["s"] = this.state.query;
      }
      getMisEnRelationApporteurs(params)
        .then((res) => {
          this.setState({ leads: res.data });
        })
        .catch((err) => {
          console.log("err", err);
          this.props.showMessage("Erreur inattendu");
        });
    })
  };

  onClose = () => {
    this.setState({ popupOpen: false });
    this.loadRelations();
  };

  openUser = (user) => {
    this.setState({ selectedUser: user, popupOpen: true });
  };

  addUser = () => this.openUser({});



  updateFilter = (field, value) => {
    let filter = this.state.filter;
    filter[field] = value;
    this.setState({ filter: Object.assign({}, filter) });
  }

  _optionStatus = [
    { name: "Tous les statuts", value: null },
    { name: "Envoyé", value: "Envoyé" },
    { name: "En cours", value: "En cours" },
    { name: "Perdu", value: "Perdu" },
    { name: "Clôturé", value: "Clôturé" }
  ];

  render() {
    return (
      <Box style={{ width: "100%" }} margin={{ top: "large" }}
        align="center" justify="center"
        alignSelf="center"
        alignContent="center" gap="medium">
        <Text size="xlarge" style={{ padding: 10 }}><b>Mis en relations</b></Text>
        <Box gap="medium">
          <Box direction='row' justify="center" alignSelf="center" align="center" gap="medium">
            <Refresh refresh={this.loadRelations} />
            <Box direction='row' gap='small'
              alignSelf="center" >
              <Box pad="xsmall" justify="center" alignContent="center"
                gap="small"
                align="center" direction="row">
                <Text size="xsmall">Select d'un statut</Text>
                <CustomSelect
                  options={this._optionStatus}
                  labelKey={"name"}
                  valueKey={{ key: "name", reduce: true }}
                  placeholder='Tous les statuts'
                  defaultValue={this._optionStatus[0]}
                  onChange={({ option }) => {
                    this.setState({
                      statut: option.value
                    });
                    this.loadRelations();
                  }}
                />
              </Box>
            </Box>
            <SearchComponent
              search={value => {
                this.setState({ query: value }, () => {
                  this.loadRelations();
                });
              }}
              query={this.state.query}
              updateQuery={value => this.setState({ query: value })}
            />
            <DateSort
              onChange={value => this.updateFilter('sort', value)}
            />
            {!this.props.isAdmin && <Button primary icon={<Add/>} label={'Ajouter une mise en relation'} onClick={()=>{
              window.open(`https://form.trustiway.com/trusti-forms/pont?ref=${this.props.apporteurRef}&apporteur_id=${getUser().id}`,'_blank');
            }} />}
          </Box>


          <Table>
            <TableHeader>
              <TableRow>
                <TableCell>
                  <Text>Création/<br />Modification</Text>
                </TableCell>
                <TableCell>
                  <Text>Nom</Text>
                </TableCell>
                <TableCell>
                  <Text>Prénom</Text>
                </TableCell>
                <TableCell>
                  <Text>Phone</Text>
                </TableCell>
                <TableCell><Text>Email</Text></TableCell>
                <TableCell><Text>Statut</Text></TableCell>
                <TableCell><Text>Apporteur</Text></TableCell>
                <TableCell><Text>Équipe de</Text></TableCell>
                <TableCell><Text>Produit</Text></TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {getSorted(this.state.leads, this.state.filter.sort).map((lead, index) => (
                <TableRow key={index + 1}>
                  <TableCell>
                    <Text size="small"><strong>{getSimpleDateFR(lead.createdAt)}</strong><br />{getSimpleDateFR(lead.updatedAt)}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.client?.lastname}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.client?.firstname}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.client?.phone}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.client?.email}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.status}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.apporteur ? `${lead.apporteur.prenom} ${lead.apporteur.nom}` : ''}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{(lead.apporteur?.apporteur_pro?.raisonSocial || '')}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{lead.produit}</Text>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    );
  }
}
export default RelationList;
